import styles from './LayerControls.module.scss';
import { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { connect, useDispatch } from 'react-redux';
import Alert from 'client/components/ui/Alert/Alert';
import Tree from 'client/components/ui/Tree/Tree';
import { MapContext } from 'os-elements';
import { hierarchy } from 'd3-hierarchy';
import { mapModes } from 'client/utils/constants/appStates';
import { addToggledLayer, removeToggledLayer } from 'client/store/layersSlice/layersSlice';
const { MODIFYING, AOI } = mapModes;

const LayerControls = ({ hierarchy, mapMode, assets }) => {
    const intl = useIntl();
    const dispatch = useDispatch();
    const { map } = useContext(MapContext);

    const [items, setItems] = useState(hierarchy);

    useEffect(() => {
        updateItems(hierarchy, assets);
    }, [hierarchy, assets]);

    const updateLayer = item => {
        const visible = item?.data?.checked && Boolean(!item?.data?.disabled);
        const layerId = item?.data?.assetType;
        const layer = map?.getLayerById(layerId);

        if (layer) {
            if (visible) {
                dispatch(addToggledLayer(layerId));
            } else {
                dispatch(removeToggledLayer(layerId));
            }
            layer.setVisible(visible);
        }
    };

    const hasAssets = (node, assets) => {
        const features = assets[node?.data?.assetType];
        return features && features.length > 0;
    };

    const isWMSLayer = (node) => {
        return node?.data?.sourceType === 'WMS';
    };

    const isWMTSLayer = (node) => {
        return node?.data?.sourceType === 'WMTS';
    };

    const isDisabled = (node, assets) => {
        if (isWMSLayer(node) || isWMTSLayer(node) || hasAssets(node, assets)) {
            return false;
        } else {
            return true;
        }
    };

    const updateItems = (hierarchy, assets) => {
        const newHierarchy = hierarchy.copy();
        newHierarchy.each(node => {
            node.data = {
                ...node?.data,
                checked: node?.data?.checked,
                onChange: updateLayer,
                disabled: node?.data?.assetType ? isDisabled(node, assets) : false
            };
        });

        setItems(newHierarchy);
    };

    return (
        <div data-testid="mapPage.menu.layerControls">
            {(!mapMode?.includes(AOI) || mapMode?.includes(MODIFYING)) &&
                <Alert
                    data-testid="mapPage.menu.info"
                    aria-label={intl.formatMessage({ id: 'mapPage.menu.info.ariaLabel' })}
                    variant="info"
                    className={styles.info}
                >
                    <p className="govuk-body-s">
                        {intl.formatMessage({ id: 'mapPage.menu.info.text.1' })}
                    </p>
                    <p className="govuk-body-s">
                        {intl.formatMessage({ id: 'mapPage.menu.info.text.2' })}
                    </p>
                    <p className="govuk-body-s">
                        {intl.formatMessage({ id: 'mapPage.menu.info.text.3' })}
                    </p>
                </Alert>
            }
            {mapMode.includes(AOI) && !mapMode.includes(MODIFYING) && items &&
                <Tree items={items}/>
            }
        </div>

    );
};

LayerControls.propTypes = {
    hierarchy: PropTypes.instanceOf(hierarchy),
    assets: PropTypes.object,
    mapMode: PropTypes.any
};

LayerControls.defaultProps = {
    layerGroups: [],
    layers: {},
    assets: {}
};

const mapStateToProps = state => {
    const { map, assets, layers } = state;

    return {
        mapMode: map?.mode || [],
        assets: assets?.layers || {},
        hierarchy: layers?.result?.hierarchy
    };
};

export default connect(mapStateToProps)(LayerControls);
